import AppHeader from '../app/appHeader';
import React, { FC, useEffect, useState } from 'react';
import './styles/paymentFailed.scss';
import { Typography } from '@getgo/chameleon-web/react';
import Footer from '../footer/footer';
import { useTranslation, Trans } from 'react-i18next';
import { useEventContext } from '../context/eventContext';
import { useParams } from 'react-router';
import { IEventUrlParameters } from '../event/eventInterface';
import API from '../utils/api';
import FullScreenLoader from '../utils/fullScreenLoader/FullScreenLoader';
import { LinksStrings } from '../../strings/links.strings';

const PaymentFailed: FC = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setLoading] = useState<boolean>(true);
  const { eventId } = useParams<IEventUrlParameters>();
  const { setEventDetails, eventDetails } = useEventContext();

  useEffect(() => {
    if (!eventDetails) {
      const getEvent = async () => {
        try {
          const eventData = await API.getEventDetails(eventId || '');
          const lang = eventData?.data?.locale?.substr(0, 2).toLowerCase() || 'en';
          if (lang && lang !== i18n.language) {
            i18n.changeLanguage(lang, () => {
              let langCopy = lang;
              if (langCopy === 'zh') {
                langCopy = 'zh-cn';
              }
              // TO-DO Change language for date
              document.documentElement.lang = langCopy;
            });
          }
          if (eventData.status === 200) {
            setEventDetails(eventData.data);
          }
        } catch (error) {
          console.log('error', error);
        }
      };
      getEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventDetails]);

  useEffect(() => {
    if (eventDetails?.locale.includes(i18n.language)) {
      setLoading(false);
    }
  }, [eventDetails?.locale, i18n.language]);
  return isLoading ? (
    <FullScreenLoader />
  ) : (
    <div className="payment-failed-grid">
      <AppHeader />
      <div className="payment-failed">
        <div className="box">
          <div className="box-space">
            <div>
              <Typography color="text-01" variant="heading-large">
                {t('paymentFailed.title')}
              </Typography>
            </div>
            <div className="payment-failed-description">
              <Typography color="text-01" variant="body-large">
                {t('paymentFailed.description')}
              </Typography>
            </div>
            <div>
              <Typography color="text-01" variant="body-large">
                <Trans i18nKey={'paymentFailed.customerSupportDetails'}>
                  For any questions, please contact our
                  <a
                    href={LinksStrings.customerSupport(i18n.language)}
                    target="_blank"
                    rel="noreferrer"
                    className="payment-failed-customer-support-link"
                  >
                    customer support
                  </a>
                </Trans>
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentFailed;
